export const arraysAreEqual = (a, b) => {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
}

export const isAudio = (file) => {
  const audioExtensions = ['.m4a', '.aac', '.wav', '.aiff', '.mp3'];
  const lowerName = file.name.toLowerCase();
  return audioExtensions.some(ext => lowerName.endsWith(ext));
};

export const isVideo = (file) => {
  const videoExtensions = ['.mov', '.mp4', '.avi', '.webm', '.mkv'];
  const fileName = file.name?.toLowerCase() || '';
  const mimeType = file.mimetype || '';
  return videoExtensions.some(ext => fileName.endsWith(ext)) || mimeType.startsWith('video/');
};